// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--rO108","disableInteractionWrap":"disableInteractionWrap--fcSmD","container":"container--dfvd8","viewer-wrapper":"viewer-wrapper--LpQ1B","viewer":"viewer--amE0z"};